/** Copyright (c) 2018, MOBICOOP. All rights reserved. This project is dual
licensed under AGPL and proprietary licence. This program is free software: you
can redistribute it and/or modify it under the terms of the GNU Affero General
Public License as published by the Free Software Foundation, either version 3 of
the License, or (at your option) any later version. This program is distributed
in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the
implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details. You should have received a
copy of the GNU Affero General Public License along with this program. If not,
see gnu.org/licenses. Licence MOBICOOP described in the file LICENSE
**************************/

<template>
  <div class="mc-form-carpool">
    <div class="mc-select-step">
      <!-- Input with placeholder -->
      <ion-item v-on:click="goGeoSearch('origin', 'post')">
        <ion-label position="stacked">{{ $t("PostCarpool.origin") }}</ion-label>
        <ion-input
          type="text"
          class="no-clickable ellipsis"
          :placeholder="$t('Search.origin')"
          :value="displayOrigin"
        ></ion-input>
      </ion-item>
      <div v-if="v$.addressessUseToPost.destination.$error">
        <div
          class="mc-error-label"
          v-if="v$.addressessUseToPost.destination.required.$invalid"
        >
          {{ $t("Validation.required") }}
        </div>
      </div>

      <div class="mc-add-step">
        <div class="mc-delete-step">
          <ion-item
            v-for="(step, index) in addressessUseToPost.step"
            :key="index"
            v-on:click="goGeoSearch('step', 'post', index)"
          >
            <ion-label position="stacked"
              >{{ $t("PostCarpool.step") }} {{ index + 1 }}</ion-label
            >
            <ion-input
              type="text"
              class="no-clickable ellipsis"
              :placeholder="$t('Search.step')"
              :value="displayStep(index)"
            ></ion-input>
            <ion-icon
              name="close"
              v-on:click="clearInputStep($event, index)"
            ></ion-icon>
          </ion-item>
        </div>

        <div
          v-if="addressessUseToPost.step.length < 4"
          v-on:click="addInputStep()"
          class="text-left d-flex align-center pointer"
        >
          <ion-icon name="add-circle-outline"></ion-icon>
          {{ $t("PostCarpool.addStep") }}
        </div>
      </div>

      <ion-item v-on:click="goGeoSearch('destination', 'post')">
        <ion-label position="stacked">{{
          $t("PostCarpool.destination")
        }}</ion-label>
        <ion-input
          type="text"
          class="no-clickable ellipsis"
          :placeholder="$t('Search.destination')"
          :value="displayDestination"
        ></ion-input>
      </ion-item>
      <div v-if="v$.addressessUseToPost.destination.$error">
        <div
          class="mc-error-label"
          v-if="v$.addressessUseToPost.destination.required.$invalid"
        >
          {{ $t("Validation.required") }}
        </div>
      </div>
    </div>

    <div
      class="mc-select-communities text-left mc-no-communities"
      v-if="
        showCommunities &&
        this.$store.getters.userCommunities &&
        this.$store.getters.userCommunities.length == 0
      "
    >
      {{ $t("PostCarpool.no-communities") }}
    </div>
    <div
      class="mc-select-communities text-left"
      v-if="
        showCommunities &&
        this.$store.getters.userCommunities &&
        this.$store.getters.userCommunities.length > 0
      "
    >
      <ion-icon
        size="large"
        color="primary"
        class="rotating"
        v-if="this.$store.getters.statusUserCommunities == 'loading'"
        name="sync"
      ></ion-icon>
      <ion-item lines="none" class="item-communities">
        <ion-label position="stacked">{{
          $t("PostCarpool.my-communities")
        }}</ion-label>
        <ion-select
          v-if="
            $store.getters.userCommunities &&
            $store.getters.statusUserCommunities == 'success'
          "
          placeholder="Sélectionnez une communauté"
          interface="alert"
          :multiple="true"
          cancel-text="Fermer"
          ok-text="Valider"
          v-model="selectedCommunities"
        >
          <ion-select-option
            v-for="community in $store.getters.userCommunities"
            :key="community.id"
            :value="parseInt(community.id)"
          >
            {{ community.name }}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </div>

    <div class="mc-carpool-distance text-center">
      <ion-icon
        size="large"
        color="primary"
        class="rotating"
        v-if="this.$store.getters.statusDistanceCarpool == 'loading'"
        name="sync"
      ></ion-icon>
      <p
        class="mc-carpool-distance-text"
        v-if="this.$store.getters.statusDistanceCarpool == 'success'"
      >
        {{ $t("PostCarpool.distance") }}
        {{ Math.ceil(this.$store.getters.distanceCarpool / 1000) }} km
      </p>
    </div>
    <div class="mc-carpool-map">
      <l-map
        v-show="
          this.$store.getters.statusDistanceCarpool != 'loading' && showCard
        "
        :center="center"
        :ref="'map'"
        :options="optionsCard"
        style="height: 250px"
        :zoom="zoom"
      >
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-polyline
          v-if="directPointsCarpool"
          :lat-lngs="directPointsCarpool"
          :color="'blue'"
        ></l-polyline>
        <l-marker
          v-if="
            addressessUseToPost.origin.latitude &&
            addressessUseToPost.origin.longitude
          "
          :lat-lng="[
            addressessUseToPost.origin.latitude,
            addressessUseToPost.origin.longitude,
          ]"
        >
          <l-icon
            :iconSize="[30, 42]"
            :iconAnchor="[15, 42]"
            className="custom-div-icon"
            ><div class="marker-pin"></div>
            <ion-icon name="pin"></ion-icon
          ></l-icon>
        </l-marker>
        <l-marker
          v-if="
            addressessUseToPost.destination.latitude &&
            addressessUseToPost.destination.longitude
          "
          :lat-lng="[
            addressessUseToPost.destination.latitude,
            addressessUseToPost.destination.longitude,
          ]"
        >
          <l-icon
            :iconSize="[30, 42]"
            :iconAnchor="[15, 42]"
            className="custom-div-icon"
            ><div class="marker-pin"></div>
            <ion-icon name="flag"></ion-icon
          ></l-icon>
        </l-marker>
      </l-map>
    </div>
  </div>
</template>

<style lang="scss">
.mc-form-carpool {
  .mc-select-step {
    margin-bottom: 40px;

    .mc-add-step {
      margin-top: 20px;
      margin-bottom: 20px;

      .mc-delete-step {
        ion-icon {
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
    }
  }

  .mc-select-communities {
    border: 1px solid #ffa000;
    border-radius: 10px;
    margin-bottom: 20px;
  }

  .mc-carpool-distance {
    border: 1px solid #ffa000;
    border-radius: 10px 10px 0px 0px;

    .mc-carpool-distance-text {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  .mc-no-communities {
    padding: 10px;
    text-align: center;
    font-size: 14px;
  }

  .item-communities {
    margin: 0px;
    padding: 5px;
    --background: transparent;
  }
}
</style>

<script>
import {
  LMap,
  LTileLayer,
  LPolyline,
  LMarker,
  LIcon,
} from "@vue-leaflet/vue-leaflet";
import {
  required,
  email,
  sameAs,
  minLength,
  helpers,
  requiredIf,
} from "@vuelidate/validators";
import { address } from "../../Shared/Mixin/address.mixin";

import { isPlatform } from "@ionic/core";
import useVuelidate from "@vuelidate/core";
import { LatLngBounds } from "leaflet";

export default {
  name: "post-carpool-step3",
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      center: [47.2350952, 2.0426357],
      zoom: 8,
      showCard: true,
      showCommunities: JSON.parse(process.env.VUE_APP_SHOW_COMMUNITIES),
      selectedCommunities: [],
      communityFree: JSON.parse(
        process.env.VUE_APP_COMMUNITY_WITH_FREE_CARPOOL
      ),
      optionsCard: {
        dragging: !isPlatform(window.document.defaultView, "mobile"),
        touchZoom: isPlatform(window.document.defaultView, "mobile"),
        tap: !isPlatform(window.document.defaultView, "mobile"),
      },
    };
  },
  mixins: [address],
  validations() {
    return {
      addressessUseToPost: {
        origin: {
          required,
        },

        destination: {
          required,
        },
      },
    };
  },
  components: {
    LMap,
    LTileLayer,
    LPolyline,
    LMarker,
    LIcon,
  },
  mounted() {
    setTimeout(() => {
      // if (!!this.$refs.map) this.$refs.map.leafletObject.invalidateSize();
      this.setBounds();
    }, 1500);
  },
  created() {
    this.selectedCommunities =
      this.$store.state.carpoolStore.carpoolToPost.communities;
    if (
      this.$store.getters.userCommunities &&
      this.$store.getters.userCommunities.length > 0 &&
      this.selectedCommunities.length == 0
    ) {
      this.selectedCommunities = this.$store.getters.userCommunities.map(
        (item) => item.id
      );
    }

    this.unwatch = this.$store.watch(
      (state, getters) => getters.currentSlider,
      (newValue, oldValue) => {
        if (oldValue != newValue && newValue == "post-carpool-step3") {
          // this.showCard = false;
          setTimeout(() => {
            this.showCard = true;
            if (!!this.$refs.map) {
              this.setBounds();
            }
          }, 1000);
        }
      }
    );
  },
  ionViewDidEnter() {
    setTimeout(() => {
      // if (!!this.$refs.map) this.$refs.map.leafletObject.invalidateSize();
      this.setBounds();
    }, 1500);
  },
  beforeDestroy() {
    this.unwatch();
  },
  computed: {
    bounds() {
      const bounds = new LatLngBounds(
        this.$store.getters.directPointsCarpool.directPoints
      );
      if (!!this.$refs.mapRecap)
        this.$refs.mapRecap.leafletObject.invalidateSize();
      return bounds;
    },

    carpoolToPost() {
      return this.$store.getters.carpoolToPost;
    },

    addressessUseToPost() {
      return this.$store.getters.addressessUseToPost;
    },

    displayOrigin() {
      const addressess = this.$store.getters.addressessUseToPost;
      return this.formatAddress(addressess.origin);
    },

    displayDestination() {
      const addressess = this.$store.getters.addressessUseToPost;
      return this.formatAddress(addressess.destination);
    },

    directPointsCarpool() {
      return this.$store.getters.directPointsCarpool.directPoints;
    },
  },
  methods: {
    setBounds() {
      let bounds;
      bounds = new LatLngBounds(
        this.$store.getters.directPointsCarpool.directPoints
      );
      if (!!this.$refs.map && this.$refs.map.leafletObject && bounds) {
        this.center = bounds.getCenter();
        this.$refs.map.leafletObject.fitBounds(bounds.pad(0.05));
        this.$refs.map.leafletObject.invalidateSize();
      }
      return bounds;
    },

    validate() {
      this.v$.$reset();
      this.v$.$touch();
      if (this.v$.$invalid) {
        return false;
      } else {
        return true;
      }
    },

    displayStep(index) {
      let result = "";
      const addressess = this.$store.getters.addressessUseToPost;
      if (!!addressess && addressess.step && addressess.step[index]) {
        if (!!addressess.step[index].displayLabel) {
          result = `${addressess.step[index].displayLabel[0]},  ${addressess.step[index].displayLabel[1]}`;
        } else if (!!addressess.step[index].addressLocality) {
          result = `${addressess.step[index].addressLocality},  ${addressess.step[index].addressCountry}`;
        }
      }

      return result;
    },

    goGeoSearch: function (type, action, index = null) {
      this.$router.push({ name: "geoSearch", query: { type, action, index } });
    },

    clearInputStep: function ($event, index) {
      $event.stopPropagation();
      this.$store.commit("removeStepByIndex", { index });
      this.$store.dispatch("treatementUpdateAddresses").then(() => {
        this.setBounds();
      });
    },

    addInputStep: function () {
      this.$store.getters.addressessUseToPost["step"].push({});
    },

    setCommunities(event) {
      this.selectedCommunities = event.detail.value;
      this.$store.state.carpoolStore.carpoolToPost.communities =
        event.detail.value;
      if (
        this.communityFree &&
        this.$store.getters.userCommunities.filter(
          (community) =>
            this.$store.state.carpoolStore.carpoolToPost.communities.includes(
              community.id
            ) && community.freeCarpool
        ).length > 0
      ) {
        if (
          this.$store.state.carpoolStore.carpoolToPost.communities.length > 0
        ) {
          this.$store.state.carpoolStore.priceCarpool = 0;
        } else {
          this.$store.dispatch("treatementUpdateAddresses");
        }
      }
    },
  },
};
</script>
